<template>
  <div class="nav" :class="{fix:isFixed}">
      <div class="m-nav-layout">
          <div class="m-nav-bg" ref="navbg"></div>
          <div class="m-nav-main">
              <div class="m-layout-center">
                <div class="m-logo-box fl">
                    <h1>
                        <router-link to="/">
                            <img src="../assets/images/logo_heng@2x.png" alt="" width="111" height="43">
                        </router-link>
                    </h1>
                </div>
                <ul class="fr">
                    <li>
                        <router-link to="/home">首页</router-link>
                    </li>
                    <!-- <li>
                        <router-link to="/ecology">数字生态</router-link>
                    </li> -->
                    <!-- <li>
                        <router-link to="/technology">核心技术</router-link>
                    </li> -->
                    <li class="m-second-list">
                        <router-link to="/solution">解决方案</router-link>
                        <div class="m-second-shadow m-second-shadow1"></div>
                        <div class="m-second-box tac">
                            <router-link to="/solution" class="routerActive">数字城市</router-link>
                            <router-link to="/solution/solutiontrade" class="routerActive">数字产业</router-link>
                            <router-link to="/solution/country/solutioncountrynumber" class="routerActive">数字国资</router-link>
                            <router-link to="/solution/solutionCard" class="routerActive">云码通证</router-link>
                        </div>
                    </li>
                    <li>
                        <router-link to="/news">新闻中心</router-link>         
                    </li>
                    <li class="m-second-list">
                        <router-link to="/about">关于我们</router-link>
                        <div class="m-second-shadow m-second-shadow2"></div>
                         <div class="m-second-box tac">
                             <router-link class="routerActive" to="/about">公司简介</router-link>
                             <router-link class="routerActive" to="/about/certification" >公司资质</router-link>
                             <a class="routerActive" target="black" href="https://www.liepin.com/company/12140653/">招聘</a>
                             <router-link class="routerActive" to="/about/platform" >联系我们</router-link>
                        </div>       
                    </li>
                    <!-- <li class="m-second-list">
                        <router-link to="/contact">联系我们</router-link>
                        <div class="m-second-shadow"></div>
                        <div class="m-second-box tac">
                            <router-link to="/contact">联系我们</router-link>
                            <router-link to="/contact/recruit">招聘</router-link>
                        </div>
                    </li> -->
                </ul>
            </div>
          </div>
      </div>
  </div>
</template>

<script>
export default {
    name: 'Nav',
    data(){
        return{
            isFixed:true,
            offsetTop:50
        }
    },
    methods:{
        handleScroll () {
            var scrollTop =  document.documentElement.scrollTop || document.body.scrollTop;
            var t = 344,
            m = Math.min(scrollTop, t) / t;
            this.$refs.navbg.style.opacity = m;
            if (scrollTop >= this.offsetTop) {
                //console.log(1);
                this.$refs.navbg.style.opacity = 0.5;
                this.isFixed = true;
            } else {
                //this.isFixed = false;
            }
        }
    },
    mounted(){
        window.addEventListener('scroll', this.handleScroll)
    },
    destroyed () {
        window.removeEventListener('scroll', this.handleScroll);
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.nav{ 
    width: 100%;
    height: 66px;
}
.fix{
    position: fixed;
    top: 0;
    z-index: 99999;
}
.m-nav-layout{
    width: 100%;
    height: 100%;
    position: relative;
}
.m-nav-bg{
    width: 100%;
    height: 100%;
    position: absolute;
    top:0;
    background-color: #333;
    opacity: 0;
}
.m-nav-main{
    width: 100%;
    height: 100%;
    position: absolute;
    top:0;
}
.m-logo-box{
    height: 66px;
    h1{
        padding-top: 11px;
        height: 44px;
    }
}

ul {
  list-style-type: none;
  padding: 0;
  height: 66px;
}
li {
    float: left;
    margin: 0 0 0 15px;
    padding:0 12px;
    height: 66px;
    > a {
        display: inline-block;
        width: 66px;
        text-align: center;
        font-size: 14px;
        color: #fff;
        height: 50px;
        line-height: 50px;
        padding: 8px 0 6px;
        &.router-link-active {
            color: #2b6fff;            
            border-bottom: 2px solid #2b6fff;
            font-weight: 700;
        }
    }
}
// li:hover{
//     // background-color: #4FBDFF;
// }
.m-second-shadow{
    display: none;
    width: 100px;
    background-color: #fff;
    position: absolute;
    top:10;
    left:0;
    opacity: 0.9;
    height: 134px;
    overflow: hidden;
    z-index: 99998;
    border-radius: 2px;
}
.m-second-shadow2{
    height: 134px;
}
.m-second-shadow1{
    height: 134px;
}
.routerActive {
    color: black;
}
.routerActive:hover {
    color: #2b6fff;
    // font-weight: 800;
}
.m-second-box{
    display: none;
    // background-color: #4FBDFF;
    width: 100px;
    position:absolute;
    padding: 10px 0 0;
    top:64px;
    left:0;
    z-index: 99999;
    //bottom: -84px;
    a{
        font-size: 12px;
        line-height: 20px;
        display: block;
        // color: #fff;
        margin-bottom: 10px;
    }
}
.m-second-list{
    position: relative;
    > a{ 
        position: relative;
        z-index: 99999;
    }
    
}
.m-second-list:hover .m-second-box,.m-second-list:hover .m-second-shadow{
    display: block;
}
.m-second-list:hover >a{
    border-bottom: 0;
}
</style>
